import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'

export const dataFunction = (colorMode: 'light' | 'dark') => [
  {
    chapter: '1',
    chapterTitle: 'Die Gesamtbevölkerung ist grösser als gedacht',
    absolutNumber: '9,7 Mio.',
    chartTitle: ['Bevölkerung (inkl. Auslandschweizer)'],
    chartParameters: [
      { barWidth: 100, barTitle: 'Bevölkerung', barColor: '#FFDA40' },
    ],
    htmlParagraph: (
      <p>
        Gut 8,9 Millionen umfasst die ständige Wohnbevölkerung der Schweiz.
        Zählt man auch die nichtständige ausländische Bevölkerung dazu,{' '}
        <a
          href='/580556987781'
          target='_blank'
          className='link'
          rel='noreferrer'
        >
          {' '}
          leben sogar schon 9 Millionen in diesem Land
        </a>
        . Wir haben aber mit ersterer Zahl gerechnet und die gut 800’000
        Auslandschweizerinnen und Auslandschweizer dazugezählt, die potenziell
        ebenfalls wählen dürfen.
      </p>
    ),
  },
  {
    chapter: '2',
    chapterTitle: 'Nicht alle dürfen wählen',
    absolutNumber: '5,59 Mio.',
    chartTitle: ['Wahlberechtigte'],
    chartParameters: [
      {
        barWidth: 57.6,
        barTitle: 'Wahlberechtigte',
        barColor: '#FFDA40',
      },
      {
        barWidth: 42.4,
        barTitle: 'Nicht Wahlberechtigte',
        barColor: '#ffe4628a',
      },
    ],
    htmlParagraph: (
      <p>
        Von diesen 9,7 Millionen dürfen viele nicht an die Urne gehen: Mehr als
        4,1 Millionen – über 42 Prozent der Bevölkerung – sind nicht
        wahlberechtigt. Zu dieser Gruppe gehören unter 18-Jährige, nicht mündige
        Bürger (zum Beispiel Menschen mit bestimmten Behinderungen) sowie
        Ausländerinnen und Ausländer, die auf Bundesebene weder an Abstimmungen
        noch an Wahlen teilnehmen können. Je nach Kanton und Gemeinde haben sie
        ein Stimm- und Wahlrecht auf kantonaler und kommunaler Ebene.
      </p>
    ),
  },
  {
    chapter: '3',
    chapterTitle: 'Nicht alle gehen wählen',
    absolutNumber: '2,6 Mio.',
    chartTitle: ['Wählende'],
    chartParameters: [
      { barWidth: 26.8, barTitle: 'Wählende', barColor: '#FFDA40' },
      {
        barWidth: 30.7,
        barTitle: 'Nichtwählende',
        barColor: '#ffe4628a',
      },
      {
        barWidth: 42.4,
        barTitle: 'Nicht Wahlberechtigte',
        barColor: '#E9E9E9',
      },
    ],

    htmlParagraph: (
      <p>
        Bleiben noch 5,59 Millionen mögliche Stimmen übrig. Doch die
        Wahlbeteiligung lag am vergangenen Sonntag lediglich bei 46,6 Prozent.
        Das heisst: Mehr als die Hälfte der Wahlberechtigten ist der Urne
        ferngeblieben. Das sind weitere 2,98 Millionen respektive 30,7 Prozent der
        Bevölkerung, die wegfallen. Effektiv teilgenommen haben am Schluss gut
        2,6 Millionen, was 26,8 Prozent der Bevölkerung entspricht.
      </p>
    ),
  },
  {
    chapter: '4',
    chapterTitle: 'Nicht alle Wahlzettel sind gültig',
    absolutNumber: '2,55 Mio.',
    chartTitle: ['Gültige Stimmen'],
    chartParameters: [
      {
        barWidth: 26.3,
        barTitle: 'Gültige Stimmen',
        barColor: '#FFDA40',
        barByline: 'no',
      },
      {
        barWidth: 0.5,
        barTitle: 'Ungültige Stimmen',
        barColor: '#ffe4628a',
        barByline: 'Ungültige Stimmen',
      },
      {
        barWidth: 30.7,
        barTitle: <>Nicht&shy;wählende</>,
        barColor: '#D4D4D4',
      },
      {
        barWidth: 42.4,
        barTitle: <>Nicht Wahl&shy;berechtigte</>,
        barColor: '#E9E9E9',
      },
    ],

    htmlParagraph: (
      <p>
        2’604’931 Wahlzettel wurden eingeworfen. Allerdings waren davon fast
        41’000 ungültig und mehr als 9600 leer. Zählt man diese ab, kommt man
        auf 2,55 Millionen Wählerinnen und Wähler, die gültige Wahlzettel
        abgegeben haben – das entspricht nur etwas mehr als einem Viertel der
        Bevölkerung.
      </p>
    ),
  },
  {
    chapter: '5',
    chapterTitle: 'Pro Partei bleibt nicht mehr viel übrig',
    absolutNumber: '',
    chartTitle: ['Stimmen für Parteien'],
    chartParameters: [
      {
        barWidth: 7.3,
        barTitle: '',
        barColor: '#4b8a3e',
        barByline: 'SVP',
      },
      {
        barWidth: 4.8,
        barTitle: '',
        barColor: '#f0554d',
        barByline: 'SP',
      },
      {
        barWidth: 3.8,
        barTitle: '',
        barColor: '#3872b5',
        barByline: 'FDP',
      },
      {
        barWidth: 3.7,
        barTitle: '',
        barColor: '#d6862b',
        barByline: 'Mitte',
      },
      {
        barWidth: 2.6,
        barTitle: '',
        barColor: '#84b547',
        barByline: 'Grüne',
      },

      {
        barWidth: 2.0,
        barTitle: '',
        barColor: '#c4c43d',
        barByline: 'GLP',
      },
      {
        barWidth: 2.1,
        barTitle: '',
        barColor: '#b8b8b8',
        barByline: 'Andere',
      },
      {
        barWidth: 0.5,
        barTitle: 'Ungültige Stimmen',
        barColor: '#C8C8D1',
      },
      {
        barWidth: 30.7,
        barTitle: <>Nicht&shy;wählende</>,
        barColor: '#D4D4D4',
      },
      {
        barWidth: 42.4,
        barTitle: <>Nicht Wahl&shy;berechtigte</>,
        barColor: '#E9E9E9',
      },
    ],
    htmlParagraph: (
      <>
        {' '}
        <p>
          Die 2’554’482 gültigen Wahlzettel teilen sich schliesslich noch auf
          die verschiedenen Parteien auf. Als Wahlsiegerin hat die{' '}
          <span className='SVP'>SVP</span> 27,9 Prozent aller Sitze im
          Nationalrat ergattert. Das entspricht umgerechnet gut 712’000
          Wählenden respektive 7,3 Prozent der Gesamtbevölkerung. Die{' '}
          <span className='SP'>SP</span> kommt als zweitstärkste Kraft auf 4,8
          Prozent. Die <span className='FDP'>FDP</span> landet knapp vor der{' '}
          <span className='Mitte'>Mitte</span>, weil sie gut 5000 Stimmen mehr
          geholt hat. Die <span className='Grünen'>Grünen</span> und die{' '}
          <span className='GLP'>GLP</span> wurden jeweils von weniger als 3
          Prozent der Bevölkerung gewählt.
        </p>
        <AutofitIFrame
          src={
            'https://datawrapper.dwcdn.net/2fqJ6/5/' +
            '?dark=' +
            String(colorMode === 'dark')
          }
          style={{ marginTop: '1em' }}
        />
        <p>
          Dass diese Zahlen so tief sind, liegt in erster Linie an der geringen
          Wahlbeteiligung. Im Vergleich zu 2019 ist diese zwar leicht gestiegen
          (von 45,1 auf 46,6 Prozent), stagniert aber seit Jahrzehnten auf
          ähnlichem Niveau. Eine Wahlpflicht ist trotzdem kein Thema in der
          Schweiz. Nur im Kanton Schaffhausen zahlt 6 Franken, wer
          wahlberechtigt ist, aber nicht an die Urne geht.
        </p>
        <p>
          Dabei zeigen{' '}
          <a
            href='/109502855639'
            target='_blank'
            className='link'
            rel='noreferrer'
          >
            {' '}
            Analysen der letzten Wahlen
          </a>
          , dass es durchaus Verschiebungen gäbe, wenn die schweigende Mehrheit
          ebenfalls wählen gehen würde: Gemäss Nachwahlbefragungen von
          Nichtwählenden hätten 2019 die FDP, die GLP und die Grünen bei einer
          (hypothetischen) hundertprozentigen Stimmbeteiligung grössere Anteile
          erhalten, wogegen SP, CVP und SVP Anteile verloren hätten. Es ist
          wahrscheinlich, dass die Nichtwählerinnen und Nichtwähler den Ausgang
          auch dieses Mal indirekt beeinflusst haben.
        </p>
      </>
    ),
  },
]
